// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3sNjg","box":"WorkspacesBox_box__2RRQi","node":"WorkspacesBox_node__1CDOM"};